import pluginRegistry from '../../plugin/PluginProvider';

export default component => {
    pluginRegistry.setRootComponent({
        path: '',
        exact: false,
        component
    });
    pluginRegistry.providePlugin(component);

    return component;
};
